var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import CoreExperiment from './CoreExperiment';
import emitter from './emitter';
import store from './store';
emitter.addActiveVariantListener((experimentName, variantName, skipSave) => {
    if (skipSave) {
        return;
    }
    store.setItem('PUSHTELL-' + experimentName, variantName);
});
export const Experiment = (_a) => {
    var props = __rest(_a, []);
    return (_jsx(CoreExperiment, Object.assign({}, props, { children: props.children })));
};
Experiment.displayName = 'Pushtell.Experiment';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwZXJpbWVudC5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJFeHBlcmltZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFDQSxPQUFPLGNBQWMsTUFBTSxrQkFBa0IsQ0FBQTtBQUM3QyxPQUFPLE9BQU8sTUFBTSxXQUFXLENBQUE7QUFDL0IsT0FBTyxLQUFLLE1BQU0sU0FBUyxDQUFBO0FBRTNCLE9BQU8sQ0FBQyx3QkFBd0IsQ0FBQyxDQUFDLGNBQXNCLEVBQUUsV0FBbUIsRUFBRSxRQUFpQixFQUFFLEVBQUU7SUFDbEcsSUFBSSxRQUFRLEVBQUU7UUFDWixPQUFNO0tBQ1A7SUFDRCxLQUFLLENBQUMsT0FBTyxDQUFDLFdBQVcsR0FBRyxjQUFjLEVBQUUsV0FBVyxDQUFDLENBQUE7QUFDMUQsQ0FBQyxDQUFDLENBQUE7QUFTRixNQUFNLENBQUMsTUFBTSxVQUFVLEdBQWMsQ0FBQyxFQUFZLEVBQUUsRUFBRTtRQUFYLEtBQUssY0FBVixFQUFZLENBQUY7SUFDOUMsT0FBTyxDQUNMLEtBQUMsY0FBYyxvQkFBSyxLQUFLLGNBQUcsS0FBSyxDQUFDLFFBQVEsSUFBa0IsQ0FDN0QsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUNELFVBQVUsQ0FBQyxXQUFXLEdBQUcscUJBQXFCLENBQUEifQ==